import { authenticatedFetch } from './base'

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @returns {*} 
 */
export const fetchUserById = (id) => {
	return authenticatedFetch(`/api/users/${id}`, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @returns {*} 
 */
export const fetchFullUserById = (id) => {
	return authenticatedFetch(`/api/users/${id}/full`, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @returns {*} 
 */
export const fetchUserNotificationSettingsById = (id) => {
	return authenticatedFetch(`/api/users/${id}/notificationsettings`, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} user 
 * @returns {*} 
 */
export const updateUserDetailsById = (user) => {
	return authenticatedFetch(`/api/users/${user.id}`, {
		method: 'put',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify(user)
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}
/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @returns {*} 
 */
export const ignoreInitialPathologiesAndProms = (id) => {
	return authenticatedFetch(`/api/users/${id}/ignoreinitialpathologies`, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({})
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @param {{}} [pathologies=[]] 
 * @param {{}} [proms=[]] 
 * @param {boolean} [isInitialSetting=false] 
 * @returns {*} 
 */
export const setPathologiesAndProms = (id, pathologies = [], proms = [], isInitialSetting = false) => {
	let url = isInitialSetting ? `/api/users/${id}/addinitialpathologies` : `/api/users/${id}/addinitialpathologies`

	return authenticatedFetch(url, {
		method: 'post',
		headers: { 'content-type': 'application/json' },
		body: JSON.stringify({ pathologies: pathologies, proms: proms })
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * @obsolete
 * Description placeholder
 *
 * @param {*} id 
 * @param {*} photo 
 * @returns {*} 
 */
export const setUserImage = (id, photo) => {
	let url = `/api/users/${id}/photo`

	return authenticatedFetch(url, {
		method: 'post',
		body: photo
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(user) {
			return user
		})
}

/**
 * Request patient's phone number verification
 *
 * @param {string} phoneCountryCode - patient's country code
 * @param {string} phoneNumber - patient' phone number
 * @returns {*} - response indicating if the action was sucessful
 */
export const requestPhoneVerificationCode = (phoneCountryCode, phoneNumber) => {
	return authenticatedFetch(`/api/patient/verifyPhone`, {
            method: 'post',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
                phoneNumber,
                phoneCountryCode
            })
        })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}

/**
 * Verify patient's phone number with the code
 *
 * @param {string} code - verification code
 * @returns {*} - response containing encrypted verification result string
 */
export const completePhoneVerification = (code) => {
	return authenticatedFetch(`/api/patient/verifyPhone/code/${code}`, {
            method: 'post'
        })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}

/**
 * @obsolete
 * Description placeholder
 *
 * @returns {*} 
 */
export const fetchMFAState = () => {
	return authenticatedFetch(`/api/patient/mfa`, { method: 'get' })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}

/**
 * Get current state of multi-factor authorization for current patient
 *
 * @returns {*} - response indicating if MFA is enabled
 */
export const checkMFAState = () => {
	return authenticatedFetch(`/api/patient/MFAState`, {
			method: 'get',
			headers: { 'content-type': 'application/json' }
		})
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}

/**
 * Update the state of multi-factor authorization for the current patient
 *
 * @param {*} type @obsolete
 * @param {*} state - new MFA state
 * @param {*} mfaSign - encrypted MFA string
 * @returns {*} - response indicating if the action was successful
 */
export const updateMFAState = (type, state, mfaSign) => {
	return authenticatedFetch(`/api/patient/mfa/${state}`,
            {
                method: 'put',
                headers: mfaSign ? { 'mfaSign': mfaSign } : {}
            })
        .then(function (response) {
            if (response.status === 200) {
                return response.json()
            }
        })
        .then(function (response) {
            return response
        })
}
